var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat-/-Empresa->-1",
    transform: "translate(-448.000000, -430.000000)",
    stroke: "#B2B2B2",
    fillRule: "nonzero",
    fill: "#B2B2B2"
  }, /*#__PURE__*/React.createElement("g", {
    id: 159694,
    transform: "translate(201.000000, 421.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(237.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5132383,23.0203666 L20.7230143,18.8105906 C21.0162933,18.5173116 21.0162933,18.0468432 20.7230143,17.7535642 C20.4297352,17.4602851 19.9592668,17.4602851 19.6659878,17.7535642 L16.7331976,20.6863544 L16.7331976,9.47454175 C16.7331976,9.05906314 16.3971487,8.72301426 15.9816701,8.72301426 C15.5661914,8.72301426 15.2301426,9.05906314 15.2301426,9.47454175 L15.2301426,20.6802444 L12.2973523,17.7474542 C12.0040733,17.4541752 11.5336049,17.4541752 11.2403259,17.7474542 C10.9470468,18.0407332 10.9470468,18.5112016 11.2403259,18.8044807 L15.4501018,23.0142566 C15.5967413,23.1608961 15.7861507,23.2342159 15.9816701,23.2342159 C16.1771894,23.2342159 16.3665988,23.1670061 16.5132383,23.0203666 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.21dcd0d46f2ec572aae809ac984932b6.svg";
export { ForwardRef as ReactComponent };